/* eslint-disable no-console */
import wrapper from 'wrapper';
import ResponsiveImage from '@bbc/news-vj-component-responsive-image';
import AnimationToggle from './components/animation-toggle/animation-toggle';
import Scrolly from './components/scrolly-custom/scrolly';
import trackScrollPosition from './utils/trackScrollPosition';

ResponsiveImage.attach(wrapper.scope); // add responsive image lazy loading script

// force to top on refresh so as not to cause issues with the scrolly
/* eslint-disable no-restricted-globals */
window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0);
});
// prevent browser auto scrolling to last known position
if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}
/* eslint-disable */

// remove fallback
wrapper.select('.scrolly-fallback').style.display = 'none';

wrapper.selectAll('.enhanced').forEach((el) => {
    el.style.display = 'block'; // eslint-disable-line no-param-reassign
});

wrapper.selectAll('.onward-journey').forEach((li) => {
    li.addEventListener('click', () => wrapper.trackUserAction('onward journey clicked', li.querySelector('a').href));
});

// initiate scrolly & toggle
new AnimationToggle();
new Scrolly();
__lazyLoad(); // eslint-disable-line

wrapper.onOptimizedScroll(() => {
    trackScrollPosition();
});

wrapper.markPageAsLoaded();